module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showBackDrop) ? _c('div', {
    staticClass: "ui dimmer page",
    staticStyle: {
      "display": "block !important"
    },
    style: ({
      visibility: _vm.showBackDrop ? 'visible' : 'hidden',
      opacity: _vm.showBackDrop ? '1' : '0'
    })
  }, [_c('transition', {
    attrs: {
      "name": "scale"
    }
  }, [_c('div', {
    staticClass: "ui center aligned middle aligned grid constatus"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', [_c('i', {
    staticClass: "bug huge icon red"
  }), _vm._v(" "), _c('h1', [_vm._v("Ooops!")]), _vm._v(" "), _c('h3', [_vm._v("It appears there has been an internal error.")]), _vm._v(" "), _c('h4', [_vm._v("We are working to fix this problem.")]), _vm._v(" "), _c('button', {
    staticClass: "ui large circular green button",
    on: {
      "click": _vm.onRefresh
    }
  }, [_c('i', {
    staticClass: "refresh icon"
  }), _vm._v("Retry")]), _vm._v(" "), _c('div', {
    staticClass: "ui horizontal divider",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Or")]), _vm._v(" "), _c('h3', [_vm._v("Contact us, If the problem persists.")])])])])])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5377549a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OnError.vue
// module id = 447
// module chunks = 28